/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface TemplateGroup {
  id?: number;
  header: string;
  parent?: TemplateGroup;
  parentId?: number;
  syncUid?: string;
  lft?: number;
  rgt?: number;
  level?: number;
  lastLevel?: boolean;
  children?: TemplateGroup[];
  templateCount?: number;
  pos?: number;
  enabled?: boolean;
  disabled?: boolean;
  deleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
